import axios from 'axios'
import { Config } from './initialConfig'
import * as Sentry from '@sentry/react'
import { upperCase } from 'lodash'
import { store } from 'store'
import { authActions } from 'store/reducers/auth'

export const URL_API = Config?.REACT_APP_API_BASE_URL

export const Axios = axios.create({
  baseURL: URL_API,
  headers: { Accept: 'application/json', 'Content-Type': ['text/plain', 'application/json'] }
})

Axios.interceptors.request.use((config) => {
  const token = store.getState().auth.access_token
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

Axios.interceptors.response.use(
  function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response
  },
  function (error) {
    if (
      [401, 403]?.includes(error?.response?.status) ||
      error?.response?.data?.errors?.[0]?.message?.includes('Invalid Token')
    ) {
      store.dispatch(authActions.logout())
    }
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error)
  }
)
